import { useMobilePanel } from '@/app-shell/layout/Navigation/mobile';
import { PatientListNavSpotlight } from '@/app-shell/layout/Navigation/PatientListNavSpotlight';
import { NavItem } from '@/app-shell/layout/Navigation/sidebar/nav-item';
import { setSidebarOpenTab } from '@/atoms/persistedPreferencesAtoms';
import { useIsEhrLaunch } from '@/hooks/integrations/useIsEhrLaunch';
import { useIsPatientListEnabled } from '@heidi/patients/flags';
import { UsersRound } from 'lucide-react';
import { useRouter } from 'next/router';
import { useCallback, useTransition } from 'react';
import { useIntl } from 'react-intl';

export const PatientsNavItem = () => {
  const intl = useIntl();
  const router = useRouter();
  const [, startTransition] = useTransition();
  const { dismissMobileSidebar } = useMobilePanel();
  const isEnabled = useIsPatientListEnabled();
  // Hide Patients in an EHR launch: the list is a route to a different patient
  // while Heidi is embedded in one patient's chart.
  const isEhrLaunch = useIsEhrLaunch();

  const onClick = useCallback(() => {
    startTransition(() => {
      setSidebarOpenTab(undefined);
    });
    dismissMobileSidebar();
  }, [dismissMobileSidebar, startTransition]);

  // "Take a look" on the launch spotlight navigates to the list and applies the
  // same sidebar-dismiss side effects as a normal nav click.
  const onShowMe = useCallback(() => {
    void router.push('/patients');
    onClick();
  }, [router, onClick]);

  if (!isEnabled || isEhrLaunch) {
    return null;
  }

  return (
    <PatientListNavSpotlight onShowMe={onShowMe}>
      <NavItem
        label={intl.formatMessage({
          defaultMessage: 'Patients',
          id: '1eiSDTlf+P',
        })}
        icon={<UsersRound />}
        href="/patients"
        onClick={onClick}
        testId="sidebar-link-patients"
      />
    </PatientListNavSpotlight>
  );
};
